var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.052,
    y: 0.026,
    style: {
      fill: "#464655"
    },
    width: 511.95,
    height: 511.95
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "512,242.527 249.472,242.527 0.052,32.485 0.052,63.268 228.926,256 0.052,448.733   0.052,479.515 249.472,269.473 512,269.473 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "0,511.974 512,511.974 512,296.417 256.026,296.417 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,0.026 0,0.026 256.026,215.583 512,215.583 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M94.361,198.817c-29.41-9.252-51.614,12.119-56.688,23.119c-4.299,9.32-12.281,51.536,27.515,58.268   c39.795,6.732,39.347-30.819,39.347-30.819c-1.795,5.984-5.012,23.039-33.738,23.039c-10.774,0-26.256-16.008-23.339-33.662   c2.746-16.611,17.584-25.109,28.8-25.583c10.621-0.448,35.381,6.882,35.381,37.028c0,33.886-34.923,37.7-34.923,37.7v20.462   c30.401-2.981,47.603-19.82,52.158-46.793C133.409,234.723,124.265,208.225,94.361,198.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M61.797,249.065c-0.694,0.881-1.064,1.977-1.082,3.098l-0.086,5.503l-1.071,1.869   c-0.387,0.675-0.157,1.536,0.515,1.928c0.68,0.398,1.553,0.164,1.944-0.52l1.098-1.921l4.395-1.592   c1.332-0.482,2.402-1.483,2.981-2.775c1.148-2.564,3.614-7.27,7.609-12.182c3.996,4.91,6.461,9.618,7.609,12.182   c0.579,1.291,1.649,2.293,2.98,2.775l4.397,1.592l1.098,1.921c0.39,0.685,1.264,0.919,1.944,0.52   c0.672-0.392,0.901-1.253,0.515-1.928l-1.071-1.869l-0.086-5.503c-0.017-1.121-0.388-2.217-1.082-3.098   c-3.682-4.676-7.598-8.352-11.457-11.605c3.084-2.898,6.569-5.665,10.961-7.801c1.016-0.495,1.547-1.635,1.285-2.734   c-0.357-1.5-1.998-2.288-3.396-1.636c-2.943,1.372-8.003,4.073-13.696,8.222c-5.693-4.15-10.753-6.85-13.696-8.222   c-1.398-0.652-3.039,0.136-3.396,1.636c-0.262,1.099,0.269,2.239,1.284,2.734c4.392,2.137,7.878,4.904,10.963,7.801   C69.395,240.713,65.478,244.389,61.797,249.065z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/vu.868335cf9644768372d3682162496bfd.svg";
export { ForwardRef as ReactComponent };